const COMMENT_FORM_MODULES = [
  {
    module: "task",
    moduleKey: "task",
    moduleLabel: "Task",
    entityType: "task",
  },
  {
    module: "matter",
    moduleKey: "matter",
    moduleLabel: "Matter",
    entityType: "matter",
  },
  {
    module: "bill",
    moduleKey: "bill",
    moduleLabel: "Bill",
    entityType: "bill",
  },
  {
    module: "contact",
    moduleKey: "contact",
    moduleLabel: "Contact",
    entityType: "contact",
  },
];

const normalizeModuleKey = (module) => {
  if (module === "people" || module === "company") {
    return "contact";
  }

  return module;
};

export const getCommentModuleDefinition = (module) => {
  const normalizedModule = normalizeModuleKey(module);

  return (
    COMMENT_FORM_MODULES.find((item) => item.module === normalizedModule) ||
    COMMENT_FORM_MODULES[0]
  );
};

export const buildPresetCommentEntity = ({
  module,
  object_id,
  object_name,
}) => {
  const moduleDefinition = getCommentModuleDefinition(module);

  if (!object_id) {
    return null;
  }

  return {
    id: object_id,
    entityType: moduleDefinition.entityType,
    moduleKey: moduleDefinition.moduleKey,
    moduleLabel: moduleDefinition.moduleLabel,
    label: object_name || `${moduleDefinition.moduleLabel} #${object_id}`,
  };
};

export const getCommentFormModuleOptions = () => COMMENT_FORM_MODULES;

export const getModuleMeta = (row, moduleType) => {
  const data = row?.full_data || row || {};
  const normalizedModule = normalizeModuleKey(moduleType);

  if (!data?.id) {
    return {
      module: normalizedModule,
      object_id: null,
      object_name: "",
    };
  }

  switch (normalizedModule) {
    case "task":
      return {
        module: "task",
        object_id: data.id,
        object_name: data.task_name || `Task #${data.id}`,
      };
    case "matter":
      return {
        module: "matter",
        object_id: data.id,
        object_name:
          data.case_name ||
          data.client_ref ||
          data.name ||
          `Matter #${data.id}`,
      };
    case "bill":
      return {
        module: "bill",
        object_id: data.id,
        object_name:
          data.invoice_num
            ? `Invoice #${data.invoice_num}`
            : data.case || `Bill #${data.id}`,
      };
    case "contact": {
      const contactName =
        data.full_name ||
        data.company_name ||
        `${data.first_name || ""} ${data.last_name || ""}`.trim() ||
        data.reminder_mail ||
        `Contact #${data.id}`;

      return {
        module: "contact",
        object_id: data.id,
        object_name: contactName,
      };
    }
    default:
      return {
        module: normalizedModule,
        object_id: data.id,
        object_name: data.name || data.title || `Record #${data.id}`,
      };
  }
};
